/* Email attachment rules (spec/32). The limits mirror what mail providers
   accept: 25 MB for the whole email, 10 files. Types are checked by extension,
   not MIME — HEIC arrives with an empty MIME type on some browsers. Anything
   not in the list is refused with a reason, never dropped. The server repeats
   every check; these are for the room parent's benefit. */

export const ATTACH_MAX_BYTES = 25 * 1024 * 1024;
export const ATTACH_MAX_FILES = 10;

export const ATTACH_KINDS = {
  jpg: ['image', 'IMG'], jpeg: ['image', 'IMG'], png: ['image', 'PNG'], gif: ['image', 'GIF'], webp: ['image', 'IMG'],
  heic: ['image', 'HEIC'], heif: ['image', 'HEIC'],
  pdf: ['pdf', 'PDF'], doc: ['doc', 'DOC'], docx: ['doc', 'DOC'], xls: ['xls', 'XLS'], xlsx: ['xls', 'XLS'], csv: ['xls', 'CSV'],
  ppt: ['ppt', 'PPT'], pptx: ['ppt', 'PPT'], txt: ['txt', 'TXT'], mp4: ['video', 'MP4'], mov: ['video', 'MOV'],
};

/* what the native picker offers, kept in step with ATTACH_KINDS. image/* lets
   a phone offer the photo library and the camera. */
export const ATTACH_ACCEPT =
  'image/*,' +
  Object.keys(ATTACH_KINDS)
    .filter((x) => ATTACH_KINDS[x][0] !== 'image')
    .map((x) => '.' + x)
    .join(',');

export function fmtBytes(n) {
  return n < 1024 * 1024
    ? Math.max(1, Math.round(n / 1024)) + ' KB'
    : (n / 1048576).toFixed(n < 10 * 1048576 ? 1 : 0) + ' MB';
}

/* { kind, label } for a file name, or null when it can't be emailed */
export function attachKind(name) {
  const ext = (String(name || '').split('.').pop() || '').toLowerCase();
  const k = ATTACH_KINDS[ext];
  return k ? { kind: k[0], label: k[1] } : null;
}

export const attachTotal = (list) => list.reduce((t, a) => t + a.size, 0);

/* Why a file can't join the draft, in the words the red note uses — or '' */
export function attachReject(file, list) {
  if (!attachKind(file.name)) return "this file type can't be emailed";
  if (!file.size) return 'the file is empty';
  if (list.some((a) => a.name === file.name && a.size === file.size)) return 'already attached';
  if (list.length >= ATTACH_MAX_FILES) return `an email can carry up to ${ATTACH_MAX_FILES} files`;
  if (file.size > ATTACH_MAX_BYTES) return `it is ${fmtBytes(file.size)} and the limit is 25 MB`;
  if (attachTotal(list) + file.size > ATTACH_MAX_BYTES) return 'it would take the email past 25 MB. Remove a file or add a link instead';
  return '';
}

/* What holds Send, in the words the hint and the phone dock use. Failed beats
   uploading: one needs the room parent, the other only needs a second. */
export function attachIssue(list) {
  if (list.some((a) => a.state === 'failed')) {
    return { long: 'An attachment did not upload. Retry it or remove it.', short: 'Attachment failed' };
  }
  if (list.some((a) => a.state === 'uploading')) {
    return { long: 'Attachments are still uploading.', short: 'Uploading attachments' };
  }
  return null;
}
